(function () {
	'use strict';

	angular
		.module('onboarding.common')
		.service('InAppMessagingService', inAppMessagingService);

	inAppMessagingService.$inject = ['$http'];

	function inAppMessagingService($http) {
		function getInAppMessage() {
			return $http.get('/api/sitecore/in-app-message');
		}

		return {
			getMessage: getInAppMessage,
		};
	}
})();
